<template>
  <FullscreenFrontageDialog ref="frontageDialog">
    <template slot-scope="dialogProps">
      <div class="share-dialog">

        <VcInputModal
          :show-dialog="showDialog"
          :useOffset="false"
          :title="$t(`client.share_dialog.title.${isInternal ? 'add' : 'share'}`)"
          @onCloseButtonClicked="handleClose">

          <template v-slot:content>
            <form class="share-dialog__content">

              <ShareDialogContent :isInternal="isInternal"
                                  :mattersList="dialogProps.mattersList"
                                  :notifyClients="notifyClients"
                                  :addToMyDocs="addToMyDocs" />

            </form>
          </template>

          <template v-slot:footer>
            <VcModalFooter
              direction="horizontal"
              :buttons='[
                {label: $t("client.share_dialog.cta.cancel"), event: "onCancelClick", color: "white"},
                {label: $t(`client.share_dialog.cta.${isInternal ? "add" : "share"}`), event: "onUploadClick", color: "secondary", loading: uploading},
                ]'
              @onUploadClick="handleSubmit"
              @onCancelClick="handleClose"
            />
          </template>

        </VcInputModal>
      </div>
    </template>
  </FullscreenFrontageDialog>
</template>

<script>
import { FullscreenFrontageDialog } from "@/modules/common/components";
import ShareDialogContent from "./ShareDialogContent";
export default {
  name: 'ShareDialog',
  components: {
    FullscreenFrontageDialog,
    ShareDialogContent
  },
  props: {
    isInternal: {
      type: Boolean,
      default: true,
    },
    mattersList: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      searchDocResults: [],
      selectedDocs: [],
      notifyClients: false,
      addToMyDocs: false,
      staffMembers: [],
      assignedStaff: '',
      clientMessage: '',
      uploading: false,
      showDialog: true
    }
  },
  methods: {
    handleClose() {
      this.showDialog = false;
      this.$refs.frontageDialog.handleClose();
    },
    handleSubmit() {
      console.log('submit')
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/abstract/_variables.scss";
@import "@/assets/scss/abstract/_mixins.scss";
.share-dialog {
  &__content {
  }
}
</style>
